var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"new-tab-com"},_vm._l((_vm.tabs),function(item,index){return _c('el-col',{key:index,attrs:{"span":24/_vm.tabs.length}},[_c('p',{class:_vm.acTab[_vm.itemKey] == item[_vm.itemKey]?'tab-com tabActive':'tab-com tab-color',on:{"click":function($event){return _vm.activeChange(item)}}},[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }